import { render, staticRenderFns } from "./FormBannerComponent.vue?vue&type=template&id=13b00fab&scoped=true"
import script from "./FormBannerComponent.vue?vue&type=script&lang=js"
export * from "./FormBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBannerComponent.vue?vue&type=style&index=0&id=13b00fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b00fab",
  null
  
)

export default component.exports